interface PopupStatusCompanyProps {
    title?: string;
    subTitle?: string;
    description?: string;
    isActive?: boolean;
    image?: React.ReactElement;
    onClose: () => void;
}

const PopupStatusCompany = ({
    title = "Your company is not active",
    subTitle = "",
    description = "Please contact the administrator to activate your company and access all features.",
    isActive = false,
    image,
    onClose
}: PopupStatusCompanyProps) => {


    return (
        <>
            <div
                className={`absolute w-screen h-screen top-0 left-0 flex items-center justify-center ${isActive ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
                style={{ backgroundColor: "#22252552", zIndex: "200", transition: "opacity 0.3s ease, visibility 0.3s ease" }}
            >
                <div
                    className={`lg:max-w-[528px] max-lg:max-w-[300px] bg-white rounded-3xl p-5 transform transition-transform duration-300 ease-in-out ${isActive ? "translate-y-0" : "translate-y-4 opacity-0"}`} style={{
                        transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}
                >
                    <div className="w-full max-lg:h-[180px] h-full">
                        {image}
                    </div>
                    <div className="space-y-2 mt-5">
                        <p className="text-[20px] font-semibold text-[#222525]">
                            {title}
                        </p>
                        <p className="text-sm font-normal text-[#6A7878]">
                            {description}
                        </p>
                        {
                            subTitle !== "" &&
                            <p className="text-sm font-normal text-[#6A7878]">
                                {subTitle}
                            </p>
                        }
                    </div>
                    <div className="flex items-end justify-end mt-6">
                        <div className="cursor-pointer" onClick={onClose} style={{ padding: "8px 24px", backgroundColor: '#0F7679', borderRadius: '30px' }}>
                            <p className="font-medium font-inter" style={{ color: "#FFFFFF", fontSize: "14px" }}>Got it</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PopupStatusCompany;